import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private location: Location, private router: Router) {}

  replaceUrl(url: string): void {
    if (this.location.getState()) {
      const parsedCurrentUrl = this.router.parseUrl(this.router.url);
      const parsedNewUrl = this.router.parseUrl(url);
      parsedNewUrl.queryParams = parsedCurrentUrl.queryParams;

      const serializedCategoryUrl = this.router.serializeUrl(parsedNewUrl);
      this.location.replaceState(serializedCategoryUrl);
    }
  }
}
